import { render, staticRenderFns } from "./InternalForgotPassword.vue?vue&type=template&id=9ae75106&scoped=true"
import script from "./InternalForgotPassword.vue?vue&type=script&lang=js"
export * from "./InternalForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./InternalForgotPassword.vue?vue&type=style&index=0&id=9ae75106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae75106",
  null
  
)

export default component.exports